/* eslint-disable */

export const IParties = ["CLIENT", "SERVICE_PROVIDER", "GENERAL_PARTNER", "DISTRIBUTOR", "ASSET"];
